export enum NotificationPackageOptions {
  PREMIUM = 'PREMIUM_PUSH',
  SKIPPED = 'SKIPPED',
}

export interface SelectNotificationPackageProps {
  onSelectPackage: (selected: NotificationPackageOptions) => void;
  openingId: string;
  priceInEur: number;
  selectedPackage?: NotificationPackageOptions;
}
